import { CoverSection, CoverSectionProps } from '@mybonus/ui';
import styled from 'styled-components';

export type StoreCoverProps = CoverSectionProps;

export const StoreCover = styled(CoverSection).attrs((props) => ({
	...props,
	withOverlayColor: true,
}))``;
